import { render, staticRenderFns } from "./StockInForm.vue?vue&type=template&id=fc0ac1d2"
import script from "./StockInForm.vue?vue&type=script&lang=js"
export * from "./StockInForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports